import React from "react";
import "./searchLoader.css";

export default function SearchLoader() {
  return (
    <div className="search-loader-backdrop">
      <div className="search-loader">
        <div className="loader-ring"></div>
        <img
          src="/assets/logo.png"
          alt="Highend Holidays"
          className="loader-logo"
        />
      </div>
      <p className="loader-text">Finding the best stays for you…</p>
    </div>
  );
}
